module.exports = __webpack_public_path__ + "static/img/no_label.24dd65b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_label.jpeg
// module id = r0bz
// module chunks = 134